import React from 'react'
import { Button } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import DutchGovLogo from '../Images/DutchGovLogo.jpeg'
import { useHistory } from 'react-router-dom'

function PricingPlan({ handleBuyNow, isFreeTrailButtonVisible }) {
  var history = useHistory();

  return (
    <>
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-10 mx-auto">
            <div className="row pricingPlan__row">
              <div className="col-md-3 col-sm-3 col-3"></div>
              <div className="col-md-3 col-sm-3 col-3"></div>
              <div className="col-md-3 col-sm-3 col-3"></div>
              <div className="col-md-3 col-sm-3 col-3 text-center">
                <img
                  src={DutchGovLogo}
                  alt="Dutch Government Logo"
                  className="img-fluid pricingPlan__dutchLogo"
                />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border"></div>
              <div className="col-md-3 col-sm-3 col-3 border text-center-md">
                <span className="pricingPlan__title">One product Post</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center-md">
                <span className="pricingPlan__title">Unlimited Product Posts</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center-md">
                <span className="pricingPlan__title">
                  <span style={{ color: 'orange' }}>Free</span> Unlimited Product
                  Posts <br />
                  <span style={{ color: 'orange' }}>
                    (For Dutch Government)
                  </span>
                </span>
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Duration 35 days</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                {/* <CheckCircleIcon className="pricing__featuresTick" /> */}<strong>NA</strong>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                {/* <CheckCircleIcon className="pricing__featuresTick" /> */}<strong>NA</strong>
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Publication in 2 languages (NL-EN)</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Email alert of your product advertisement to candidates</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                Email alert when applicant applies for posted product
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Get Retailer Profile page</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Product post with Store logo</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Candidate email, phone details</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>After 35 days free product extend option</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                {/* <CheckCircleIcon className="pricing__featuresTick" /> */}<strong>NA</strong>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                {/* <CheckCircleIcon className="pricing__featuresTick" /> */}<strong>NA</strong>
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Receive Applicant CV's</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Receive new registered CV's (CV Alert)</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CancelIcon className="pricing__featuresCross" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>

              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <span>Access to CV database</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CancelIcon className="pricing__featuresCross" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center pricingPlan__columns">
                <CheckCircleIcon className="pricing__featuresTick" />
              </div>
            </div>
            <div className="row pricingPlan__row mt-3">
              <div className="col-md-3 col-sm-3 col-3 text-center p-1"></div>
              <div className="col-md-3 col-sm-3 col-3 border text-center p-1 pricingPlan__priciColumns">
                Free
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center p-1 pricingPlan__priciColumns">
                € 120.00 <span style={{ fontSize: '13px' }}>Per Month</span>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center p-1 pricingPlan__priciColumns">
                Free
              </div>

              <div className="col-md-3 col-sm-3 col-3 text-center p-1"></div>
              <div className="col-md-3 col-sm-3 col-3 text-center p-1"></div>
              <div className="col-md-3 col-sm-3 col-3 text-center p-1">
                <Button
                  variant="contained"
                  className="pricing__btnFreeTrail"
                  onClick={() => handleBuyNow('Freetrial', 0, true)}
                  disabled={isFreeTrailButtonVisible}
                >
                  Free trial for 30 days
                </Button>
              </div>
              <div className="col-md-3 col-sm-3 col-3 border text-center p-1"></div>
            </div>
            <div className="row pricingPlan__row">
              <div className="col-md-3 col-sm-3 col-3 text-center p-1"></div>
              <div className="col-md-3 col-sm-3 col-3 text-center p-1">
                <Button
                  variant="contained"
                  className="pricing__btnBuyNow"
                  onClick={() => handleBuyNow('Starter', 0)}
                  disabled={isFreeTrailButtonVisible}
                >
                  Register
                </Button>
              </div>
              <div className="col-md-3 col-sm-3 col-3 text-center p-1">
                {isFreeTrailButtonVisible ?
                  <Button
                    variant="contained"
                    className="pricing__btnBuyNow"
                    onClick={() => history.push('/payment-page')}
                  >
                    Buy Now
                  </Button>
                  : <Button
                    variant="contained"
                    className="pricing__btnBuyNow"
                    onClick={() => handleBuyNow('Ultimate', 0)}
                  >
                    Buy Now
                  </Button>}
              </div>
              <div className="col-md-3 col-sm-3 col-3 p-1">
                <Button
                  variant="contained"
                  className="pricing__btnBuyNow"
                  onClick={() => handleBuyNow('Overheid', 0)}
                  disabled={isFreeTrailButtonVisible}
                >
                  Register
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PricingPlan
